module.exports = __webpack_public_path__ + "img/446ab49.jpg";